import showModal from './modals/modal';

let errorModal = function (errorMessage) {
	return showModal({
		id: 'Error',
		header: 'Error',
		body: errorMessage,
	});
};

export default errorModal;
